import { Header } from "../../components/laxmi/Chrome";
import { api, when } from "../../lib/api";

export default function Notifications({ data, setPage, onRefresh }) {
  const markRead = async id => { await api.patch(`/notifications/${id}`, { read: true }); await onRefresh(); };
  const readAll = async () => { await api.post("/notifications/read-all"); await onRefresh(); };
  const list = data.notifications;
  return (
    <div className="screen">
      <Header title="Notifications" onBack={() => setPage("account")} onBell={() => {}} />
      {list.some(n => !n.read) && <button className="read-all" onClick={readAll} data-testid="mark-all-read-button">Mark all as read</button>}
      <div className="notification-list">{list.length ? list.map(n => (
        <button className={`notification-item ${n.read ? "read" : "unread"}`} key={n.notification_id} onClick={() => markRead(n.notification_id)} data-testid={`notification-${n.notification_id}`}>
          <span>{n.read ? "✉" : "🔔"}</span><div><b>{n.title}</b><small>{n.text}</small><time>{when(n.created_at)}</time></div>{!n.read && <i>New</i>}
        </button>)) : <div className="empty" data-testid="empty-notifications">No notifications</div>}</div>
    </div>
  );
}
